import { render } from "./DashboardPricingFollowup.vue?vue&type=template&id=1b677eba&scoped=true"
import script from "./DashboardPricingFollowup.vue?vue&type=script&lang=js"
export * from "./DashboardPricingFollowup.vue?vue&type=script&lang=js"

import "./DashboardPricingFollowup.vue?vue&type=style&index=0&id=1b677eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b677eba"]])

export default __exports__